<template>
  <div class="bg-warning default-border-radius mb-2 p-2 text-white">
    <LabelAndValue
      :i18n-key="'summaryPanel.asset.total'"
      :value="`${formatWithMask(getTotalAllAssets(), 2)}  €`"
      :oneLine="true"
      :label-style="'text-white'"
      :value-style="valueStyleTotal"
      :div-value-style="'d-flex justify-between'"
    />
  </div>

  <div v-for="(item, index) in assets" v-bind:key="index" class="">
    <div class="bg-secondary default-border-radius p-2 tw-items-dashed-group">
      <LabelAndValue
        :i18n-key="`Asset ${formatWithMask(index + 1)}`"
        :value="`${formatWithMask(totalPriceWithTax(index), 2)}  €`"
        :oneLine="true"
        :label-style="'text-primary'"
        :value-style="'text-primary'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue
        class="itemBar"
        :i18n-key="'good.goodDetails.goodGeneralInfo.generalInformations'"
        :value="''"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue v-if="item.config?.assetType === assetBoat || item.config?.assetType === assetEquipment"
        class="itemsBar"
        :i18n-key="'demand.asset.boat.type'"
        :value="getType(item)"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue
        class="itemsBar"
        :i18n-key="'order.item.generalInfo.from'"
        :value="getselectedAssetFrom(item)"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue
        class="itemsBar"
        :i18n-key="'demand.asset.category'"
        :value="getCategory(item)"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue
        class="itemsBar"
        :i18n-key="'demand.asset.subCategory'"
        :value="getSubCategory(item)"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue  v-if="item.config?.assetType === assetVehicule || item.config?.assetType === assetEquipment"
        class="itemsBar"
        :i18n-key="'summaryPanel.asset.quantite'"
        :value="item.quantity"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue
        class="itemsBar"
        :i18n-key="'demand.asset.vehicle.brand'"
        :value="getBrand(item.brand)"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue
        class="itemsBar"
        :i18n-key="'demand.asset.vehicle.model'"
        :value="getModel(item)"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue
        class="itemsBar"
        :i18n-key="'summaryPanel.asset.description'"
        :value="item.description"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue v-if="item.config?.assetType === assetVehicule || item.config?.assetType === assetEquipment"
        class="itemsBar"
        :i18n-key="item.config?.assetType === assetVehicule ? 'summaryPanel.asset.asset' : 'summaryPanel.asset.priceTTC'"
        :value="`${formatWithMask(item.totalAmountWTax.amount, 2)}  €`"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue v-if="item.config?.assetType === assetVehicule"
        class="itemsBar"
        :i18n-key="'demand.asset.matriculation'"
        :value="item.matriculation ? item.matriculation : '-'"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue v-if="item?.config?.assetType===assetVehicule"
        class="itemsBar"
        :i18n-key="'demand.asset.matriculationDate'"
        :value="item.matriculationDate ? item.matriculationDate : '-'"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue v-if="item.config?.assetType === assetBoat"
        class="itemsBar"
        :i18n-key="'demand.asset.boat.nbEngine'"
        :value="item.nbEngine ? item.nbEngine : '-'"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue v-if="item.config?.assetType === assetBoat"
        class="itemsBar"
        :i18n-key="'demand.asset.boat.priceTtc'"
        :value="`${formatWithMask(totalPriceWithTax(index), 2)}  €`"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue
        class="itemBar"
        :i18n-key="'demand.asset.deliveryDetails'"
        :value="''"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue
        class="itemsBar"
        :i18n-key="'demand.asset.deliveryDate'"
        :value="item.assetDelivery && item.assetDelivery.deliveryDate ? item.assetDelivery.deliveryDate : '-'"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue
        class="itemsBar"
        :i18n-key="'demand.asset.supplier'"
        :value="getSupplierName(item)"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue
        class="itemsBar"
        :i18n-key="'demand.asset.address'"
        :value="getSupplierAddress(item)"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />

      <LabelAndValue v-if="item.config?.assetType === assetBoat"
        class="itemsBar"
        :i18n-key="'demand.asset.boat.orderSigned'"
        :value="item.assetDelivery && item.assetDelivery.orderSigned ? item.assetDelivery.orderSigned ? $t(`demand.asset.boat.orderSignedSituation.yes`) : $t(`demand.asset.boat.orderSignedSituation.no`) : '-'"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />

      <LabelAndValue v-if="item.config?.assetType === assetBoat"
        class="itemsBar"
        :i18n-key="'demand.asset.boat.orderSignedDate'"
        :value="item.assetDelivery && item.assetDelivery.orderSignatureDate ? item.assetDelivery.orderSignatureDate : '-' "
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />

      <LabelAndValue v-if="item.config?.assetType === assetVehicule || item.config?.assetType === assetBoat" 
        class="itemBar"
        :i18n-key="'summaryPanel.asset.totalFrais'"
        :value="`${formatWithMask(proposalAssetItemsTotalWithTax(index), 2)}  €`"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />

      <LabelAndValue
        class="itemsBar"
        :i18n-key="'summaryPanel.asset.options'"
        v-if="proposalAssetOptionItems.length && (item.config?.assetType === assetVehicule || item.config?.assetType === assetBoat)"
        :value="`${formatWithMask(proposalAssetOptionItemsTotalWithTax(index), 2)}  €`"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />

      <LabelAndValue
        class="itemsBar"
        :i18n-key="'summaryPanel.asset.options'"
        v-if="!proposalAssetOptionItems.length && (item.config?.assetType === assetVehicule || item.config?.assetType === assetBoat)"
        :value="`${formatWithMask(0, 2)}  €`"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />

      <LabelAndValue
        class="itemsBar"
        :i18n-key="'summaryPanel.asset.accessories'"
        v-if="proposalAssetAccessoryItems.length && (item.config?.assetType === assetVehicule || item.config?.assetType === assetBoat)"
        :value="`${formatWithMask(proposalAssetAccessoryItemsTotalWithTax(index), 2)}  €`"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />
      <LabelAndValue
        class="itemsBar"
        :i18n-key="'summaryPanel.asset.accessories'"
        v-if="!proposalAssetAccessoryItems.length && (item.config?.assetType === assetVehicule || item.config?.assetType === assetBoat)"
        :value="`${formatWithMask(0, 2)}  €`"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />

      <LabelAndValue 
        class="itemsBar"
        :i18n-key="'summaryPanel.asset.fairsDivers'"
        v-if="proposalAssetOtherItems.length && (item.config?.assetType === assetVehicule || item.config?.assetType === assetBoat)"
        :value="`${formatWithMask(proposalAssetOtherItemsTotalWithTax(index), 2)}  €`"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />

      <LabelAndValue
        class="itemsBar"
        :i18n-key="'summaryPanel.asset.fairsDivers'"
        v-if="!proposalAssetOtherItems.length && (item.config?.assetType === assetVehicule  || item.config?.assetType === assetBoat)"
        :value="`${formatWithMask(0, 2)}  €`"
        :oneLine="true"
        :label-style="'text-dark'"
        :div-value-style="'d-flex justify-between'"
      />


    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import LabelAndValue from "@/components/general/LabelAndValue.vue";
import { formatWithMask } from "@/utils/configuration/formatters-config";
import { AssetTypeEnum, ProposalAssetItem, ProposalAssetItemType } from "@/types";
import i18n from "@/i18n";

@Options({
  methods: { formatWithMask },
  components: { LabelAndValue },
  props: ["asset"],
})
/**
 * Summary panel component rendering asset totals and options.
 */
export default class SummaryAsset extends Vue {
  readonly asset: any;

  option = ProposalAssetItemType.option;
  other = ProposalAssetItemType.other;
  accessory = ProposalAssetItemType.accessory;
  assetEquipment = AssetTypeEnum.EQUIPMENT
  assetBoat = AssetTypeEnum.BOAT
  assetVehicule = AssetTypeEnum.VEHICULE

  get assets() {
    return this.asset.proposalAssets;
  }

  getTotalAllAssets() {
    let totalAssets = 0;
    for (let i = 0; i <= this.assets.length - 1; i++) {
      totalAssets += this.totalPriceWithTax(i);
    }
    return totalAssets;
  }

  assetItem(index: number) {
    return this.assets[index];
  }

  totalPriceWithTax(index: number) {
    const totalAmountWTax = this.assetItem(index)
      ? this.assetItem(index).totalAmountWTax.amount || 0
      : 0;
    return this.proposalAssetItemsTotalWithTax(index) + totalAmountWTax || 0;
  }

  proposalAssetItems(index: number) {
    return this.assetItem(index) ? this.assets[index].proposalAssetItems || [] : [];
  }
  proposalAssetItemsTotalWithTax(index: number) {
    return this.proposalAssetItems(index)
      .filter((item: any) => item.config.selected)
      .reduce((a: number, b: ProposalAssetItem) => {
        return a + (b.totalAmountWTax?.amount || 0);
      }, 0);
  }

  proposalAssetOptionItems(index: number) {
    return (this.assetItem(index).proposalAssetItems || []).filter(
      (item: any) => item.type.resourceUid === this.option
    );
  }

  proposalAssetOptionItemsTotalWithTax(index: number) {
    return this.proposalAssetOptionItems(index)
      .filter((item: any) => item.config.selected)
      .reduce((a: number, b: ProposalAssetItem) => {
        return a + (b.totalAmountWTax?.amount || 0);
      }, 0);
  }

  proposalAssetAccessoryItems(index: number) {
    return (this.assetItem(index).proposalAssetItems || []).filter(
      (item: any) => item.type.resourceUid === this.accessory
    );
  }
  proposalAssetAccessoryItemsTotalWithTax(index: number) {
    return this.proposalAssetAccessoryItems(index)
      .filter((item: any) => item.config.selected)
      .reduce((a: number, b: ProposalAssetItem) => {
        return a + (b.totalAmountWTax?.amount || 0);
      }, 0);
  }
  proposalAssetOtherItems(index: number) {
    return (this.assetItem(index).proposalAssetItems || []).filter(
      (item: any) => item.type.resourceUid === this.other
    );
  }

  proposalAssetOtherItemsTotalWithTax(index: number) {
    return this.proposalAssetOtherItems(index)
      .filter((item: any) => item.config.selected)
      .reduce((a: number, b: ProposalAssetItem) => {
        return a + (b.totalAmountWTax?.amount || 0);
      }, 0);
  }
  getselectedAssetFrom(item:any) {
      const value = item.config?.productAssetModel?.config?.inventoryItems
      if (value && value.length > 0){
        return i18n.global.t("order.asset.selectAssetFrom.inventory")
      }
      else {
        return i18n.global.t("order.asset.selectAssetFrom.catalog")
    }
  }
  getBrand(brand: string) {
    return brand ? brand.replace(/asset.good.vehicle.brand./g, "") : "";
  }
  getCategory(item:any){
    return item.proposalAssetCategories && item.proposalAssetCategories[0]&& item.proposalAssetCategories[0].category&& item.proposalAssetCategories[0].category.value ? i18n.global.t("demand.asset.categoryItems."+item.proposalAssetCategories[0].category.value ): "-"
  }
  getSubCategory(item:any){
    return item.proposalAssetCategories && item.proposalAssetCategories[0]&& item.proposalAssetCategories[0].categoryClass&& item.proposalAssetCategories[0].categoryClass.value ? i18n.global.t("demand.asset.subCategoryItems." + item.proposalAssetCategories[0].categoryClass.value.substring(item.proposalAssetCategories[0].categoryClass.value.lastIndexOf(".") + 1) ): "-"
  }
  getModel(item: any) {
    return item.config && item.config.formBind && item.config.formBind.range && item.config.formBind.range.label ? item.config.formBind.range.label : "-";
  }
  getSupplierName(item: any) {
    return item.config && item.config.formBind && item.config.formBind.supplier && item.config.formBind.supplier.name ? item.config.formBind.supplier.name : "-"
  }
  getSupplierAddress(item: any) {
    return item.config && item.config.formBind && item.config.formBind.supplierAddress? item.config.formBind.supplierAddress : "-" 
  }
 getType(item: any) {
    let type = "-"
    if (item && item?.config?.assetType) {
      switch (item?.config?.assetType) {
        case this.assetEquipment:
          item.flagNew ? type = i18n.global.t("demand.asset.equipment.equipmentType.NEW") : type = i18n.global.t("demand.asset.equipment.equipmentType.OLD")
          break;
        case this.assetBoat:
          item.flagNew ? type = i18n.global.t("demand.asset.boat.boatType.NEW") : type = i18n.global.t("demand.asset.boat.boatType.OLD")
          break;
      }
    }
    return type
  }
  valueStyle = {
    "font-weight": "bold",
    "margin-left": "20px",
   
  };

  valueStyleTotal = {
    "font-weight": "bold",
    color: "#1976D2",
  };

  divValueStyle = {
    display: "flex",
    "justify-content": "end",
    "padding-right": "0.5rem",
  };

  divValueItem = {
    display: "flex",
    "justify-content": "end",
    "padding-right": "0.5rem",
  };

  divValueItems = {
    display: "flex",
    "justify-content": "end",
    "padding-right": "0.5rem",
  };

  labelStyleTotal = {
    "font-weight": "bold",
    "font-size": "1rem",
    color: "#1976D2",
  };

  labelStyleAsset = {
    "font-weight": "bold",
    "font-size": "1rem",
    color: "black",
  };

  labelStyleItems = {
    "font-weight": "bold",
    "font-size": "1rem",
    color: "gray",
  };
}
</script>

<style scoped>
.totalBar {
  display: flex;
  align-items: center;
  padding: 16px 0 8px 0;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.assetBar {
  display: flex;
  align-items: center;
  padding: 5px 0 5px 0;
}

.itemBar {
  display: flex;
  align-items: center;
  padding: 10px 10px 10px 10px;
}

.itemsBar {
  display: flex;
  align-items: center;
  padding: 0 10px 0 20px;
}

.borderRadius {
  border-radius: 20px;
}
</style>
